import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminActivity() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/activity").then((r) => setItems(r.data)); }, []);
  return (
    <div>
      <h1 className="font-display text-3xl font-black text-[#0a1e3f]">Journal d'activité</h1>
      <p className="text-sm text-gray-500 mt-1">Événements récents de la plateforme.</p>
      <div className="mt-6 bg-white rounded-2xl border border-gray-100 mbk-card-shadow p-6 space-y-2">
        {items.length === 0 ? <div className="text-gray-400 text-center py-10">Aucun événement.</div> :
          items.map((a) => (
            <div key={a.id} className="flex justify-between text-sm border-b border-gray-100 pb-2">
              <span><span className="font-semibold text-[#0a1e3f]">{a.type}</span> · {a.ref}</span>
              <span className="text-xs text-gray-400">{new Date(a.at).toLocaleString("fr-FR")}</span>
            </div>
          ))}
      </div>
    </div>
  );
}
